import React from "react";
import { ErrorPanel } from "@smb/ui-error-panel";

import { trackComponentErrorTrace } from "../../../utils/telemetry/trackComponentErrorTrace";
import { ErrorBoundary, FallbackProps } from "../error-boundary";

import { getLaunchErrorMessage } from "./utils/getLaunchErrorMessage";

export const AppLaunchErrorBoundary: React.FC<React.PropsWithChildren<any>> = ({
  children,
}) => {
  return (
    <ErrorBoundary
      FallBackComponent={AppLaunchNotFound}
      onError={trackComponentErrorTrace}
    >
      {children}
    </ErrorBoundary>
  );
};

const AppLaunchNotFound: React.FC<FallbackProps> = ({ error }) => {
  const { description, title, altMessage } = getLaunchErrorMessage(error);

  return (
    <ErrorPanel
      truncateDescription
      description={description}
      title={title}
      imgProps={{
        alt: altMessage,
      }}
    />
  );
};
